import { inject } from '@angular/core';
import { Route, Router, ActivatedRouteSnapshot } from '@angular/router';
import { CampaignGuard } from '@kanek/shared-data-access';

export const appRoutes: Route[] = [
  // Campaign error page (no guard needed)
  {
    path: 'campaign-error',
    loadComponent: () => import('./campaign-error/campaign-error.component').then(m => m.CampaignErrorComponent),
  },
  
  // Protected experience routes - all require valid campaign
  {
    path: 'experience',
    loadComponent: () => import('./experience/experience.component'),
    canActivate: [CampaignGuard],
  },
  {
    path: 'experience/play',
    loadComponent: () => import('./play/play.component'),
    canActivate: [CampaignGuard],
  },
  {
    path: 'experience/win',
    loadComponent: () => import('./win/win.component'),
    canActivate: [CampaignGuard],
  },
  {
    path: 'experience/redeem',
    loadComponent: () => import('./redeem/redeem.component'),
    canActivate: [CampaignGuard],
  },
  
  // Utility routes
  {
    path: 'api/version',
    loadComponent: () => import('./version/version.component'),
  },

  // Default redirects
  {
    path: '',
    redirectTo: redirectToExperience,
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: redirectToExperience,
  },
];

function redirectToExperience(redirectData: Pick<ActivatedRouteSnapshot, 'queryParams'>) {
  const router = inject(Router);
  const sid = redirectData.queryParams['s'];

  if (sid) {
    // Return UrlTree for experience with short code
    return router.createUrlTree(['/experience'], {
      queryParams: { s: sid },
    });
  } else {
    // No short code provided - redirect to campaign error page
    return router.createUrlTree(['/campaign-error'], {
      queryParams: {
        status: 'missing_short_code',
        message: 'No campaign code was provided in the link.',
        shortCode: '',
        actions: JSON.stringify([
          'Check that you scanned the QR code correctly',
          'Ask for a new link from the venue',
          'Contact support if the problem persists'
        ])
      }
    });
  }
}
